import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  declare readonly inputTarget: HTMLElement
  private observer?: MutationObserver
  private hasSubmitted = false

  private minFontSize = 0.5
  private maxFontSize = 4.5
  private step = 0.05
  private paddingFactorWidth = 0.85
  private paddingFactorHeight = 0.83
  private finalAdjust = 0.93

  connect() {
    this.adjustFontSize(true)
    this.observer = new MutationObserver(() => this.adjustFontSize(false))
    this.observer.observe(this.inputTarget, {
      characterData: true,
      childList: true,
      subtree: true,
    })
    window.addEventListener("resize", this.adjustFontSizeBound)
  }

  disconnect() {
    this.observer?.disconnect()
    window.removeEventListener("resize", this.adjustFontSizeBound)
  }

  private adjustFontSizeBound = this.adjustFontSize.bind(this)

  private adjustFontSize(_from_connect) {
    const el = this.inputTarget
    const form = el.closest("form")
    if (!form) return

    const text = el.textContent?.trim() || ""
    if (!text) return

    const isCleanVersion = form.classList.contains("mx-auto") || el.classList.contains("font-cardo")

    const parentRect = form.getBoundingClientRect()
    const maxWidth = parentRect.width * this.paddingFactorWidth
    const maxHeight = parentRect.height * this.paddingFactorHeight

    let fontSize = this.maxFontSize
    form.style.fontSize = `${fontSize}em`

    let { width, height } = el.getBoundingClientRect()

    while ((width > maxWidth || height > maxHeight) && fontSize > this.minFontSize) {
      fontSize -= this.step
      form.style.fontSize = `${fontSize}em`
      ;({ width, height } = el.getBoundingClientRect())
    }

    fontSize *= this.finalAdjust

    const fontSizeToSave = isCleanVersion ? fontSize + 1.1 : fontSize

    form.style.fontSize = `${fontSizeToSave}em`
    form.dataset.fontSize = `${fontSizeToSave.toFixed(2)}em`
    const hiddenField = form.querySelector<HTMLInputElement>(
      'input[name="outer_section[cover_page_title_font_size]"]',
    )
    if (hiddenField) {
      hiddenField.value = `${fontSizeToSave.toFixed(2)}em`
    }

    if (!this.hasSubmitted && !_from_connect) {
      this.hasSubmitted = true
      form.requestSubmit()
    }
  }
}
